import { appBar, glass, theme } from "../../../utils/theme";

const nav = {
  alignItems: "center",
  borderBottomColor: theme.palette.grays[300],
  borderBottomStyle: "solid",
  borderBottomWidth: 0,
  display: "flex",
};

export const styles = {
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  margin: {
    display: "flex",
    margin: theme.spacing(1),
  },
  navRoot: {
    ...nav,
    transition: "all 0.1s ease",
  },
  toolbar: {
    gap: 16,
    height: appBar.height,
    pb: 0,
    pl: `0 !important`,
    pr: `0 !important`,
    pt: 0,
  },
};
